// One item of the left menu. When the role may not open it, it says "no access" and a click explains why instead
// of opening the page.
import type { MouseEvent } from 'react'
import { Link, useLocation } from 'react-router-dom'
import { notify } from '@the-kit/ui'
import { activeMenuPath, type MenuItem } from '../menus'
import { useMe } from '../session'
import { useSidebar } from './useSidebar'

const testIdOf = (path: string) => 'menu-' + (path === '/' ? 'overview' : path.slice(1).replace(/\//g, '-'))

export function MenuLink({ item, count }: { item: MenuItem; count: number }) {
  const { can } = useMe()
  const closeOnPhone = useSidebar((state) => state.setOpen)
  const locked = !!item.need && !can(item.need)
  const active = activeMenuPath(useLocation().pathname) === item.path
  const onClick = (event: MouseEvent) => {
    if (!locked) return closeOnPhone(false)
    event.preventDefault()
    notify.warning('No access', 'Your role cannot open that page.')
  }
  return (
    <Link
      to={item.path}
      onClick={onClick}
      className={locked ? 'nav-item opacity-60' : `nav-item ${active ? 'nav-item-active' : ''}`}
      aria-current={active ? 'page' : undefined}
      data-testid={testIdOf(item.path)}
    >
      <item.icon size={15} className="shrink-0" />
      <span>{item.label}</span>
      {count > 0 && !locked && (
        <span className="ml-auto rounded-full bg-accent px-1.5 text-2xs font-bold text-charcoal">
          {count}
        </span>
      )}
      {locked && <span className="ml-auto text-2xs uppercase text-muted">no access</span>}
    </Link>
  )
}
